import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firebaseConfig';
import { ref, onValue, remove } from 'firebase/database';
import './AdminErrors.css';

function AdminErrors() {
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const errorRef = ref(db, 'systemErrors');
    const unsubscribe = onValue(errorRef, (snapshot) => {
      setLoading(true);
      if (snapshot.exists()) {
        const data = snapshot.val();
        const parsedErrors = Object.keys(data).map(key => ({
          dbId: key,
          ...data[key]
        }));
        
        // Sort newest first
        parsedErrors.sort((a, b) => (b.metadata?.timestamp || 0) - (a.metadata?.timestamp || 0));
        setErrors(parsedErrors);
      } else {
        setErrors([]);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const clearLogs = async () => {
    if (window.confirm("Are you sure you want to clear all error logs?")) {
      try {
        await remove(ref(db, 'systemErrors'));
        setErrors([]);
      } catch (err) {
        alert("Failed to clear logs: " + err.message);
      }
    }
  };

  const filteredErrors = errors.filter(err => {
    if (filter === 'all') return true;
    if (filter === '404') return err.errorCode?.includes('404');
    if (filter === 'runtime') return !err.errorCode?.includes('404');
    return true;
  });

  return (
    <div className="admin-errors-page animate-up">
      <div className="admin-page-header">
        <div className="header-info">
          <h1>System Error Monitor</h1>
          <p>Real-time tracking of ERxxxx tracking IDs encountered by users.</p>
        </div>
        <div className="header-actions">
          <select 
            className="filter-select" 
            value={filter} 
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">All Errors</option>
            <option value="404">404 Failures</option>
            <option value="runtime">Runtime Exceptions</option>
          </select>
          <button className="btn btn-danger btn-sm" onClick={clearLogs}>
            <i className="fa-solid fa-trash-can"></i> Clear Logs
          </button>
        </div>
      </div>

      <div className="error-grid">
        {loading ? (
          <div className="loading-state">Syncing with Error Daemon...</div>
        ) : filteredErrors.length === 0 ? (
          <div className="empty-state">
            <i className="fa-solid fa-shield-check"></i>
            <p>No active system errors reported.</p>
          </div>
        ) : (
          filteredErrors.map(error => (
            <div key={error.dbId} className={`error-card ${error.errorCode?.includes('404') ? 'type-404' : 'type-error'}`}>
              <div className="error-card-header">
                <span className="error-id">{error.errorCode}</span>
                <span className="error-timestamp">
                  {new Date(error.metadata?.timestamp).toLocaleString()}
                </span>
              </div>
              <div className="error-card-body">
                <h3 className="error-message">{error.message}</h3>
                <div className="error-meta-row">
                  <span className="meta-label">Path:</span>
                  <code className="meta-value">{error.path}</code>
                </div>
                <div className="error-meta-row">
                  <span className="meta-label">User ID:</span>
                  <span className={`meta-value ${error.userId === 'GUEST' ? 'guest' : 'authenticated'}`}>
                    {error.userId}
                  </span>
                </div>
              </div>
              <div className="error-card-footer">
                <span className="ua-text" title={error.metadata?.userAgent}>
                  <i className="fa-solid fa-laptop-code"></i> {error.metadata?.userAgent?.split(') ')[1] || 'Unknown Client'}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AdminErrors;
